import { render, staticRenderFns } from "./distributionUserLists.vue?vue&type=template&id=b96887f2&scoped=true&"
import script from "./distributionUserLists.vue?vue&type=script&lang=js&"
export * from "./distributionUserLists.vue?vue&type=script&lang=js&"
import style0 from "./distributionUserLists.vue?vue&type=style&index=0&id=b96887f2&scoped=true&lang=css&"
import style1 from "./distributionUserLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96887f2",
  null
  
)

export default component.exports